export enum TimeFormat {
  D = "D",
  W = "W",
  M = "M",
  Y = "Y",
}

export interface MiniPackagesResponse {
  id: number;
  entitlement_id: string;
  title: string;
  price: string;
  thumbnail: string;
  banner: string;
  created_at: string;
  description: string;
  is_subscribed: boolean;
  role_id: number;
  color?: string;
  slug: string;
  service_end_date: string;
  plan_period_format: TimeFormat;
}

export interface mainPackageResponse {
  id: number;
  entitlement_id: string;
  title: string;
  price: string;
  thumbnail: string | null;
  created_at: string;
  description: string;
  role_id: number;
  is_subscribed: boolean;
  color: string;
  slug: string;
  plan_period_format: TimeFormat;
}

export interface subscriptionsResponse {
  main: Array<mainPackageResponse>;
  mini: Array<MiniPackagesResponse>;
}

export interface PackageDetails {
  id: number;
  entitlement_id: string;
  title: string;
  price: string;
  thumbnail: string;
  banner?: string;
  created_at: string;
  description: string;
  is_subscribed: boolean;
  contents: any;
  plan_period_format: TimeFormat;
  service_end_date?: string;
  slug?: string;
  color?: string;
}

export interface GenericResponse<T> {
  data: T;
  message: string;
  status: boolean;
}

export interface Transection {
  id: number;
  user_id: number;
  amount: number;
  title: string;
  currency: string;
  status: string;
  failure_reason: string;
  created_at: string;
  invoice_link: string;
}

export interface ActivePackages {
  id: number;
  user_id: number;
  description: string;
  title: string;
  status: string;
  purchased_formatted_date: string;
  thumbnail: string;
  color: string;
  amount: string;
  current_period_end: string;
  cancel_at_period_end: string;
  canceled_at: string;
  created_at: string;
  updated_at: string;
  entitlement_id: string;
  plan_period_format: TimeFormat;
}

export enum ContentType {
  MOVIES = "movie",
  TV_SHOWS = "tv_show",
  TV_CHANNELS = "tv_channel",
  RADIO_STATIONS = "radio_station",
  PODCASTS = "podcast",
  SONGS = "song",
  ALBUMS = "album",
  CREATOR_VIDEOS = "creator_video",
  CREATOR_PLAYLISTS = "creator_playlist",
}
